import { TransmissibilityDisruptionFactorType } from 'client/dto';
import { Typography } from 'components/_common/Typography';
import React from 'react';

type TransmissibilitySummaryProps = {
  transmissibility: TransmissibilityDisruptionFactorType;
  diseaseName: string;
  locationName: string;
  parentLocationName?: string;
};

const TransmissibilitySummary: React.FC<TransmissibilitySummaryProps> = ({
  transmissibility,
  diseaseName,
  locationName,
  parentLocationName,
}) => {
  switch (transmissibility) {
    case TransmissibilityDisruptionFactorType.PossibleViaHumanToHuman: {
      return (
        <div data-testid="transmissibility-summary">
          Infected individuals commonly
          <Typography variant="subtitle1" inline>
            {' '}
            spread {diseaseName} directly to others
          </Typography>
        </div>
      );
    }
    case TransmissibilityDisruptionFactorType.PossibleViaEnvironmentLocally: {
      return (
        <div data-testid="transmissibility-summary">
          Infected individuals in {locationName}
          <Typography variant="subtitle1" inline>
            {' '}
            could spread {diseaseName} to others via the environment
          </Typography>
        </div>
      );
    }
    case TransmissibilityDisruptionFactorType.PossibleViaEnvironment: {
      return (
        <div data-testid="transmissibility-summary">
          Infected individuals in regions or all of {parentLocationName}
          <Typography variant="subtitle1" inline>
            {' '}
            could spread {diseaseName} to others via the environment
          </Typography>
        </div>
      );
    }
    case TransmissibilityDisruptionFactorType.Unlikely: {
      return (
        <div data-testid="transmissibility-summary">
          Based on historic data, infected
          <Typography variant="subtitle1" inline>
            {' '}
            individuals in {locationName} are unlikely to spread {diseaseName} (via the environment)
          </Typography>
        </div>
      );
    }
    case TransmissibilityDisruptionFactorType.LimitedViaHumanToHuman: {
      return (
        <div data-testid="transmissibility-summary">
          Infected individuals could spread {diseaseName} directly to others, however,
          <Typography variant="subtitle1" inline>
            {' '}
            transmission mode may limit spread
          </Typography>
        </div>
      );
    }
    case TransmissibilityDisruptionFactorType.NotPossibleUnlessLocally:
    case TransmissibilityDisruptionFactorType.NotPossible: {
      return (
        <div data-testid="transmissibility-summary">
          <Typography variant="subtitle1" inline>
            Not possible for an infected individual to spread {diseaseName}
          </Typography>{' '}
          to others or to the environment
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

export default TransmissibilitySummary;
